export default {
// ur-PK.js
help: {
  faq: "عمومی سوالات",
  promo: "پرومو",
  contactUs: "ہم سے رابطہ کریں",
  joinCommunity: "ہماری کمیونٹی میں شامل ہوں",
  help: "مدد"
}
};
